import { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate, useOutletContext } from "react-router-dom";
// helpers
import { pagesUrl, appSection, hotelPanelRootUrl } from "../../common/utils/panel-helpers/helpers";
// components
import FormMessage from "../../components/FormMessage";
import SectionLoader from "../../components/SectionLoader";
// @ts-ignore
import { CustomButton } from "@gl-shared/shared/ui";
// @ts-ignore
import { CustomTable } from "@gl-shared/shared/ui";
// actions
import { loginsActionCreators } from "../../common/store/modules/loginsModule";

const tableHeadRows = [
  { title: "Name", column: "full_name" },
  { title: "Email", column: "email" },
  {
    title: "Role",
    column: "hotel_manager",
    edited: {
      func: (item: any) => {
        return item?.hotel_manager ? "Manager" : "Concierge";
      }
    }
  }
];

const Logins = (props: any) => {
  const navigate = useNavigate();
  const outletContext: any = useOutletContext();

  useEffect(() => {
    // call logins initially (after we get hotel-info data) and on every hotel change
    if (props?.hotelData?.hotelUserId) {
      outletContext.loadLogins(props.selectedHotels[0]?.id);
    }
  }, [props.selectedHotels[0]?.id, props.hotelData]);

  const addLoginForm = () => {
    window.scrollTo(0, 0);
    navigate(`/${hotelPanelRootUrl}/${pagesUrl.addLogins}`);
  };

  const editLoginForm = (selectedLogin: any) => {
    window.scrollTo(0, 0);
    props.setSelectedLoginAction(selectedLogin);
    navigate(`/${hotelPanelRootUrl}/${pagesUrl.editLogins}`);
  };

  return (
    <div className="logins component">
      {props.sectionLoadingNames === null || props.sectionLoadingNames?.includes(appSection?.logins) ? (
        <SectionLoader loadingLabel="LOADING LOGINS" />
      ) : (
        <>
          {props.formData?.form === "AddLogin" ||
          props.formData?.form === "EditLogin" ||
          props.formData?.form === "DeleteLogin" ? (
            <FormMessage
              form={props.formData?.form}
              formError={props.formData?.formError}
              formSuccessful={props.formData?.formSuccessful}
            />
          ) : null}
          {props.formData?.form === "HotelSelectionNotice" && (
            <FormMessage form={props.formData?.form} hotelName={props.formData?.hotelName} />
          )}
          <div className="row">
            <div className="col-lg-8">
              <div className="ibox">
                <div className="ibox-title">
                  <h5>Logins</h5>
                  <CustomButton
                    isDisabled={false}
                    mainClass="btn-green"
                    customClasses="btn-green--height-l btn-green--auto-width"
                    onClick={addLoginForm}
                    buttonText="ADD LOGIN"
                  />
                </div>
                <div className="ibox-content">
                  <CustomTable
                    emptyTableMessage={"No logins created yet"}
                    customClasses="panel__table logins__table"
                    tableHead={tableHeadRows}
                    tableItems={props?.logins}
                    tableButtonClick={(item: any) => editLoginForm(item)}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  formData: state.global.formData,
  sectionLoadingNames: state.global.sectionLoadingNames,
  selectedHotels: state.global.selectedHotels,
  logins: state.logins.logins,
  hotelData: state.home.hotelData
});

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      setSelectedLoginAction: loginsActionCreators.setSelectedLoginAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Logins);
